import { useEffect, useState } from "react";
import { Container, Row, Col, Spinner, Modal } from "react-bootstrap";

const Gallery = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);

  // modal state
  const [show, setShow] = useState(false);
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    const formData = new FormData();
    formData.append("page", "gallery");
  
    fetch("https://skillsuprise.com/get-gallery.php", {
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(data => {
        console.log("API RESPONSE:", data); // debug
  
        if (data.status === "success") {
          setImages(data.data);
        } else {
          console.log("No data found");
        }
  
        setLoading(false);
      })
      .catch(err => {
        console.error(err);
        setLoading(false);
      });
  }, []);

  const handleOpen = (img) => {
    setActiveImage(img);
    setShow(true);
  };

  const handleClose = () => setShow(false);

  return (
    <div style={{ background: "#f5f7fa", minHeight: "100vh", padding: "40px 0" }}>
      <Container>
        <h2 className="text-center fw-bold mb-4">Gallery</h2>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Row>
            {images.map((item, index) => (
              <Col md={4} lg={3} key={index} className="mb-4">
                <div
                  onClick={() => handleOpen(item)}
                  style={{
                    cursor: "pointer",
                    borderRadius: "15px",
                    overflow: "hidden",
                    position: "relative",
                    boxShadow: "0 8px 20px rgba(0,0,0,0.1)"
                  }}
                >
                  {/* Image */}
                  <img
                    src={item.image_url}
                    alt="gallery"
                    style={{
                      width: "100%",
                      height: "220px",
                      objectFit: "cover",
                      transition: "0.3s"
                    }}
                  />

                  {/* Hover Overlay */}
                  <div
                    style={{
                      position: "absolute",
                      bottom: 0,
                      left: 0,
                      right: 0,
                      background: "rgba(0,0,0,0.6)",
                      color: "#fff",
                      padding: "10px",
                      fontSize: "13px",
                      opacity: 0,
                      transition: "0.3s"
                    }}
                    className="gallery-overlay"
                  >
                    {item.title || "Skillsuprise Event"}
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </Container>

      {/* 🔥 MODAL (IMAGE PREVIEW) */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Body className="p-0">
          {activeImage && (
            <>
              <img
                src={activeImage.image_url}
                alt="preview"
                style={{ width: "100%" }}
              />
              <div className="p-3">
                <h6>{activeImage.title || "Gallery Image"}</h6>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>

      {/* 🔥 HOVER CSS */}
      <style>
        {`
        .gallery-overlay:hover {
          opacity: 1 !important;
        }

        div:hover > .gallery-overlay {
          opacity: 1 !important;
        }

        div:hover img {
          transform: scale(1.05);
        }
        `}
      </style>
    </div>
  );
};

export default Gallery;